
import React from 'react';
import PropTypes from 'prop-types';

import useFitTextToContent from '../../../hooks/useFitTextToContent';
import SidebarPanelButton from '../SidebarPanelButton';
import {
  FLOATING_TOOLBAR_ICON_SIZE,
  StyledFloatingToolbarButton,
} from '../FloatingToolbar.styled';
import { FitTextToContent } from '../../../utils/editorReactIcons';

const FitTextToContentAction = ({
  annotationIds,
  variant = 'sidebar',
  className = '',
  t,
}) => {
  const { fitTextToContent, canFitTextToContent } =
    useFitTextToContent(annotationIds);

  const title = t('fitTextToContentTitle') || 'Fit box to text';
  const label = t('fitTextToContentShort') || 'Fit';

  if (!canFitTextToContent) {
    return null;
  }

  if (variant === 'floating') {
    return (
      <StyledFloatingToolbarButton
        type="button"
        className={`respark_floating-toolbar-btn respark_floating-toolbar-btn--fit-text ${className}`.trim()}
        title={title}
        aria-label={title}
        onClick={fitTextToContent}
      >
        <FitTextToContent size={FLOATING_TOOLBAR_ICON_SIZE} />
      </StyledFloatingToolbarButton>
    );
  }

  return (
    <SidebarPanelButton
      className={`respark_fit-text-option respark_annotation-option-triggerer ${className}`.trim()}
      Icon={FitTextToContent}
      label={label}
      title={title}
      onClick={fitTextToContent}
    />
  );
};

FitTextToContentAction.propTypes = {
  annotationIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  variant: PropTypes.oneOf(['sidebar', 'floating']),
  className: PropTypes.string,
  t: PropTypes.func.isRequired,
};

export default FitTextToContentAction;
